import { Button } from './Button';

export default function ErrorState({ message = 'Erro ao carregar', retry }: { message?: string; retry?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-red-600">
      <span className="text-sm font-medium mb-2">{message}</span>
      {retry && (
        <Button onClick={retry} variant="outline" size="sm">
          Tentar novamente
        </Button>
      )}
    </div>
  );
}
